import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ResponseList } from 'models/Response';
import { AdminMasterEmployeeResponse } from 'data/MasterEmployee/schemas/MasterEmployee.shema';

export type UseMasterEmployeeConfigProps = {
    enabled?: boolean;
    company?: string;
    userId?: string;
    employeeName?: string;
    roleAccess?: string;
};

export function useMasterEmployeeConfig(props?: UseMasterEmployeeConfigProps) {
    return useQuery({
        enabled: props?.enabled,
        queryKey: ['master-employee-config', props || {}],
        queryFn: ({ signal }) => {
            const accessToken = localStorage.getItem('WF_APPLICATION');
            return axios.get<AdminMasterEmployeeResponse[]>(
                '/v1/configuration/GetMasterEmployee',
                {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    params: {
                        company: props?.company,
                        userId: props?.userId,
                        employeeName: props?.employeeName,
                        roleAccess: props?.roleAccess
                    }
                }
            );
        },
        select: response => response.data
    });
}
